<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<nz-spin nzSize="large" [nzTip]="loadingMessage" [nzSpinning]="isLoading">
  <nz-alert
    *ngIf="isBomStatusUnavailable$ | async"
    nzType="warning"
    nzShowIcon
    nzMessage="BOM status unavailable"
    nzDescription="Close the drawer and try again after the Material BOM has loaded."
  ></nz-alert>

  <nz-alert
    class="bottom-spacing"
    nzType="error"
    nzShowIcon
    nzCloseable
    nzMessage="Error"
    [nzDescription]="errorTpl"
    *ngIf="submitError"
  ></nz-alert>

  <ng-template #errorTpl>
    <em-error-result *ngIf="submitError" [subTitle]="submitError"></em-error-result>
  </ng-template>

  <form nz-form *ngIf="bomForm" [formGroup]="bomForm" (ngSubmit)="submitForm(bomForm)">
    <!-- material -->
    <nz-form-item>
      <nz-form-label nzRequired nzFor="material">Material</nz-form-label>
      <nz-form-control nzHasFeedback [nzErrorTip]="materialErrorTpl">
        <em-generic-select
          id="material"
          formControlName="component"
          valueKey="materialNumber"
          nameKey="materialDescription"
          [service]="materialSearchService"
          [search]="materialSearchService"
        ></em-generic-select>
      </nz-form-control>

      <ng-template #materialErrorTpl let-control>
        <ng-container *ngIf="control.errors['required']">
          Please input a material number!
        </ng-container>
      </ng-template>
    </nz-form-item>
    <!-- /material -->

    <!-- weight -->
    <nz-form-item>
      <nz-form-label nzRequired nzFor="weight">Weight (1 pc)</nz-form-label>
      <nz-form-control nzHasFeedback [nzErrorTip]="weightErrorTpl">
        <!--
          REMARK: This is actually the weight for 1000 pieces in KG.
                  But business is used to copying this value from a single piece in grams.
                  Luckily 1 pieces in grams is the same value for 1000 pieces in KG.
                  So we "trick" them here to not confuse them.

                  TL;DR;
                  Displaying Grams is correct, but it's really KG.
        -->
        <nz-input-group nzPrefixIcon="dashboard" nzSuffix="grams">
          <input
            id="weight"
            nz-input
            type="number"
            formControlName="weight"
            placeholder="Please enter the weight"
          />
        </nz-input-group>
      </nz-form-control>

      <ng-template #weightErrorTpl let-control>
        <ng-container *ngIf="control.errors['required']">Please input a weight!</ng-container>
      </ng-template>
    </nz-form-item>
    <!-- /weight -->

    <!-- sort string -->
    <nz-form-item>
      <nz-form-label nzFor="sortString">Sort string</nz-form-label>
      <nz-form-control nzHasFeedback>
        <nz-input-group nzPrefixIcon="sort-ascending">
          <input
            nz-input
            type="number"
            id="sortString"
            formControlName="sortString"
            placeholder="Please enter the sort string"
          />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <!-- /sort string -->

    <!-- eco number -->
    <nz-form-item *ngIf="isBomLocked">
      <nz-form-label nzRequired nzFor="engineeringChangeOrderNumber">ECO number</nz-form-label>
      <nz-form-control nzHasFeedback [nzErrorTip]="ecoErrorTpl">
        <input
          id="engineeringChangeOrderNumber"
          nz-input
          formControlName="engineeringChangeOrderNumber"
          placeholder="Please enter an ECO number"
        />
      </nz-form-control>

      <ng-template #ecoErrorTpl let-control>
        <ng-container *ngIf="control.errors['required']">Please input an ECO number!</ng-container>
      </ng-template>
    </nz-form-item>
    <!-- eco number -->

    <!-- actions -->
    <nz-form-item>
      <nz-form-control>
        <button type="submit" nz-button nzType="primary" [disabled]="!bomForm.valid">
          <i nz-icon nzType="save" nzTheme="fill"></i>
          Submit
        </button>
      </nz-form-control>
    </nz-form-item>
    <!-- /actions -->
  </form>
</nz-spin>
